// extracted by mini-css-extract-plugin
export default {"card_horizontal":"styles_card_horizontal__bz0Ku","card_horizontal_data":"styles_card_horizontal_data__01dHg"};